import { blutenProducts } from './data/bluten';
import { extrakteProducts } from './data/extrakte';
import { ICamProductOptions, ICamUnitOptions } from './data/shared';

export const CamProductList: ICamProductOptions[] = [
    {
        label: "Blüten",
        options: [
            ...blutenProducts,
            { label: "Freitext" }
        ]
    },
    {
        label: "Extrakte",
        options: [
            ...extrakteProducts,
            { label: "Freitext" }
        ]
    },
    {
        label: "Dronabinol",
        options: []
    },
    {
        label: "Sativex",
        options: []
    },
    {
        label: "Canemes",
        options: []
    },
    {
        label: "Kapseln",
        options: [
            { label: "Avextra Kapsel 2,5 mg THC / 2,5 mg CBD", thc_cbd: "2,5/2,5" },
            { label: "Avextra Kapsel 5 mg THC / 5 mg CBD", thc_cbd: "5/5" },
            { label: "Freitext" }
        ]
    },
    {
        label: "Andere",
        options: [{ label: "Freitext" }]
    }
];

export const CamUnitList: ICamUnitOptions[] = [
    {
        label: "Blüten",
        options: [
            "Milligramm Cannabisblüten (inhalativ)",
            "Anzahl Kapseln mit Cannabisblüten (inhalativ)",
            "Milligramm Cannabisblüten (oral)",
            "Freitext"
        ]
    },
    {
        label: "Extrakte",
        options: [
            "Milliliter (Kolbenpipette)",
            "Anzahl Hübe (Dosierpumpe)",
            "Anzahl Tropfen (Senkrechttropfer)",
            "mg THC/CBD",
            "Freitext"
        ]
    },
    {
        label: "Dronabinol",
        options: [
            "Milliliter (Kolbenpipette)",
            "Anzahl Hübe (Dosierpumpe)",
            "Anzahl Tropfen (Senkrechttropfer)",
            "mg THC",
            "Freitext"
        ]
    },
    {
        label: "Sativex",
        options: ["Anzahl Sprühstöße", "Freitext"]
    },
    {
        label: "Canemes",
        options: ["Anzahl Kapseln", "Freitext"]
    },
    {
        label: "Kapseln",
        options: [
            "Anzahl Kapseln",
            "Milligram THC",
            "Milligram CBD",
            "Freitext"
        ]
    },
    {
        label: "Andere",
        options: [
            "Milligramm THC",
            "Milligramm CBD",
            "Freitext"
        ]
    }
];
